import React from 'react';

import Icon from 'components/atoms/icons/icon';

import { StyledSocialList, StyledSocialItem } from './SocialStyles';

const Social = ({ socialsData, fullWidth, black = false, small = false }) => (
  <StyledSocialList fullWidth={fullWidth}>
    {socialsData &&
      socialsData.map(({ id, name, url }) => (
        <a href={url} target="_blank" rel="noreferrer">
          <StyledSocialItem key={id} small={small} black={black}>
            <Icon name={name} small={small} black={black} />
          </StyledSocialItem>
        </a>
      ))}
  </StyledSocialList>
);

export default Social;
